import { LessonProperty } from "../../../Modules/Account/CustomerLessonProperties";
import { CompPackOrderLessonProgramValues } from "./CompPackOrderLessonProgramValues";
import { CompPackOrderLessonValues } from "./CompPackOrderLessonValues";
import { CompPackOrderRentalValues } from "./CompPackOrderRentalValues";
import { CompPackOrderTicketValues } from "./CompPackOrderTicketValues";

export class CompPackBookingValues {
    constructor(projNr?: number, packageId?: number, tariffSheetId?: number, soapDateStart?: string, soapDateEnd?: string) {
        this.projNr = projNr;
        this.packageId = packageId;
        this.tariffSheetId = tariffSheetId;
        this.soapDateStart = soapDateStart;
        this.soapDateEnd = soapDateEnd;
        this.ticketOrderValues = new Array<CompPackOrderTicketValues>();
        this.rentalOrderValues = new Array<CompPackOrderRentalValues>();
        this.additionalRentalOrderValues = new Array<CompPackOrderRentalValues>();
        this.lessonProgramOrderValues = new Array<CompPackOrderLessonProgramValues>();
        this.lessonOrderValues = new Array<CompPackOrderLessonValues>();
        this.accountId = 0;
        this.gender = '';
        this.height = 0;
        this.weight = 0;
        this.shoeSize = 0;
        this.skillLevel = 0;
        this.pickupLocationId = 0;
    }

    projNr: number = 0;
    packageId: number = 0;
    tariffSheetId: number = 0;
    soapDateStart: string = '';
    soapDateEnd: string = '';

    accountId: number = 0;
    gender: string = '';
    height: number = 0;
    weight: number = 0;
    shoeSize: number = 0;
    skillLevel: number = 0;
    pickupLocationId: number = 0;

    lessonAllergies: LessonProperty[] = [];
    lessonMedicals: LessonProperty[] = [];
    lessonLanguages: LessonProperty[] = [];
    lessonLevels: LessonProperty[] = [];

    ticketOrderValues: CompPackOrderTicketValues[] = [];
    rentalOrderValues: CompPackOrderRentalValues[] = [];
    additionalRentalOrderValues: CompPackOrderRentalValues[] = [];
    lessonProgramOrderValues: CompPackOrderLessonProgramValues[] = [];
    lessonOrderValues: CompPackOrderLessonValues[] = [];
}